import fetch from 'isomorphic-fetch';
import {/*API_URL, */API2_URL, GOAL_EDIT, GOAL_FAIL, GOALS_REQUEST, GOALS_SHOW, GOALS_FETCH, GOAL_DELETE, GOAL_ACTIVITIES, GOAL_COMPLETE, GOAL_CLEAR} from "../store/config";
import {newNotification} from "./notifications";
import {history} from './../store/store';
import _ from "lodash";
import {sessionService} from "redux-react-session";
import {axisList} from "./axis";
import {linesList} from "./lines";
import {activitiesList} from "./activities";
import {modalitiesList} from "./modalities";
import {entitiesList} from "./entities";
//import {statusList} from "./status";
import {statusGroupList} from "./status";


export const fetchGoalComplete = (id = undefined) => (dispatch) => {
	dispatch(goalsRequest());
	dispatch(goalsClear());
	dispatch(entitiesList());
	return dispatch(axisList())
		.then((axis) => {
			if(!_.isEmpty(axis.payload)){
				return dispatch(linesList())
					.then((lines) => {
						if(!_.isEmpty(lines.payload)){
							return dispatch(activitiesList())
								.then((activities) => {
									if(!_.isEmpty(activities.payload)){
										return dispatch(modalitiesList())
											.then((modalities) => {
												if(!_.isEmpty(modalities.payload)){

													return dispatch(statusGroupList())
														.then((status) => {
															if(!_.isEmpty(status.payload)){
																if(id){
																	return dispatch(fetchGoal(id))
																}else {
																	return dispatch(goalsComplete())
																}
															}else {
																return dispatch(goalsFail('Carga incompleta'))
															}
														})

												}else {
													return dispatch(goalsFail('Carga incompleta'))
												}
											})
									}else {
										return dispatch(goalsFail('Carga incompleta'))
									}
								})
						}else {
							return dispatch(goalsFail('Carga incompleta'))
						}
					})
			}else {
				return dispatch(goalsFail('Carga incompleta'))
			}
		})

}

export const goalsShow = (page = 1, filters={}) => {
	return dispatch => {
		return dispatch(sessionService.loadUser)
			.then(sess => {
				const options = {
					headers: {
						'Accept': 'application/json',
						'Content-Type': 'application/json',
						'Authorization': `Bearer ${sess.profile.access_token}`
					},
					method: 'get'
				};

				let params = '';
				_.mapKeys(filters, (value, key) => {
					if(value){
						params = `${params}&${key}=${value}`;
					}
				});

				dispatch(goalsRequest());
				return fetch(`${API2_URL}/proigualdad/goals?page=${page}${params}`, options)
					.then(result => {
						if (result.status >= 200 && result.status < 300) {
							return result.json();
						} else {
							return result.json().then(Promise.reject.bind(Promise));
						}
					})
					.then(
						json => dispatch(goalsData(json)),
						error => {
							dispatch(newNotification({title: "¡Oh no!", content: error.message ? (error.errors ? `${error.message} - ${_.values(error.errors)}`:error.message):_.values(error), type: "danger"}));
							return dispatch(goalsFail(error.message ? (error.errors ? `${error.message} - ${_.values(error.errors)}`:error.message):_.values(error)));
						}
					)
			})
	}
};

export const goalsList = (modality_id = undefined, agenciable_id = undefined) => {
	return dispatch => {
		return dispatch(sessionService.loadUser)
			.then(sess => {
				const options = {
					headers: {
						'Accept': 'application/json',
						'Content-Type': 'application/json',
						'Authorization': `Bearer ${sess.profile.access_token}`
					},
					method: 'get'
				};

				dispatch(goalsRequest());
				return fetch(`${API2_URL}/proigualdad/goals?include[0]=modality&include[1]=activities.verification_media${modality_id ? `&modality_id=${modality_id}`:''}${agenciable_id ? `&agenciable_id=${agenciable_id}`:''}&status_id=1&per_page=all`, options)
					.then(result => {
						if (result.status >= 200 && result.status < 300) {
							return result.json();
						} else {
							return result.json().then(Promise.reject.bind(Promise));
						}
					})
					.then(
						json => dispatch(goalsListData(json)),
						error => {
							dispatch(newNotification({title: "¡Oh no!", content: error.message ? (error.errors ? `${error.message} - ${_.values(error.errors)}`:error.message):_.values(error), type: "danger"}));
							return dispatch(goalsFail(error.message ? (error.errors ? `${error.message} - ${_.values(error.errors)}`:error.message):_.values(error)));
						}
					)
			})
	}
};

/*Fetch Goal Edit*/
const fetchGoal = (id) => (dispatch) => {
	//dispatch(goalsRequest());
	return dispatch(goalEdit(id))
		.then((goal) => {
			if(!_.isEmpty(goal.payload)){
				return dispatch(goalActivities(id))
					.then((activities) => {
						if(!_.isEmpty(activities.payload)){
							return dispatch(goalsComplete())
						}else {
							return dispatch(goalsFail(activities.error))
						}
					})
			}else {
				return dispatch(goalsFail(goal.error))
			}
		})
}

const goalEdit = (id) => {
	return dispatch => {
		return dispatch(sessionService.loadUser)
			.then(sess => {
				const options = {
					headers: {
						'Accept': 'application/json',
						'Content-Type': 'application/json',
						'Authorization': `Bearer ${sess.profile.access_token}`
					},
					method: 'get'
				};

				return fetch(`${API2_URL}/proigualdad/goals/${id}`, options)
					.then(result => {
						if (result.status >= 200 && result.status < 300) {
							return result.json();
						} else {
							return result.json().then(Promise.reject.bind(Promise));
						}
					})
					.then(
						json => dispatch(goalEditData(json)),
						error => {
							dispatch(newNotification({title: "¡Oh no!", content: error.message ? (error.errors ? `${error.message} - ${_.values(error.errors)}`:error.message):_.values(error), type: "danger"}));
							return dispatch(goalsFail(error.message ? (error.errors ? `${error.message} - ${_.values(error.errors)}`:error.message):_.values(error)));
						}
					);
			})
	}
};

/*Goals Activities*/
const goalActivities = (id) => {
	return dispatch => {
		return dispatch(sessionService.loadUser)
			.then(sess => {
				const options = {
					headers: {
						'Accept': 'application/json',
						'Content-Type': 'application/json',
						'Authorization': `Bearer ${sess.profile.access_token}`
					},
					method: 'get'
				};

				return fetch(`${API2_URL}/proigualdad/goals/${id}/activities?include[0]=goal_activity`, options)
					.then(result => {
						if (result.status >= 200 && result.status < 300) {
							return result.json();
						} else {
							return result.json().then(Promise.reject.bind(Promise));
						}
					})
					.then(
						json => dispatch(activitiesGoalEditData(json)),
						error => {
							dispatch(newNotification({title: "¡Oh no!", content: error.message ? (error.errors ? `${error.message} - ${_.values(error.errors)}`:error.message):_.values(error), type: "danger"}));
							return dispatch(goalsFail(error.message ? (error.errors ? `${error.message} - ${_.values(error.errors)}`:error.message):_.values(error)));
						}
					);
			})
	}
};

/*Save Goal*/
export const goalSave = (values) => (dispatch) => {
	dispatch(goalsRequest());

	if(!_.isEmpty(values.activities)){
		return dispatch(goalEditSave(values))
			.then((goal) => {
				if(!_.isEmpty(goal.payload)){
					return dispatch(goalActivitiesSave(values, goal.payload.id/*, activities*/))
						.then((activity) => {
							if(!_.isEmpty(activity.payload)){
								if(values.id){
									return dispatch(goalsComplete());
								}
							}
						})
				}
			})
	}else {
		dispatch(newNotification({title: "¡Oh no!", content: "La Meta debe de contener minimo una actividad", type: "danger"}));
		return dispatch(goalsFail("La Meta debe de contener minimo una actividad"));
	}
}

const goalEditSave = (values) => {
	return dispatch => {
		return dispatch(sessionService.loadUser)
			.then(sess => {
				const options = {
					headers: {
						'Accept': 'application/json',
						'Content-Type': 'application/json',
						'Authorization': `Bearer ${sess.profile.access_token}`
					},
					method: 'post',
					body: JSON.stringify(values)
				};

				return fetch(`${API2_URL}/proigualdad/goals${values.id ? `/${values.id}?_method=PUT`:''}`, options)
					.then(result => {
						if (result.status >= 200 && result.status < 300) {
							return result.json();
						} else {
							return result.json().then(Promise.reject.bind(Promise));
						}
					})
					.then(
						json => {
							dispatch(newNotification({title: "Éxito", content: json.message ? json.message:"La meta se ha guardado correctamente", type: "success"}));
							return dispatch(goalEditData(json))
						},
						error => {
							dispatch(newNotification({title: "¡Oh no!", content: error.message ? (error.errors ? `${error.message} - ${_.values(error.errors)}`:error.message):_.values(error), type: "danger"}));
							return dispatch(goalsFail(error.message ? (error.errors ? `${error.message} - ${_.values(error.errors)}`:error.message):_.values(error)));
						}
					);
			})
	}
};

/*Goal Activities Save*/
const goalActivitiesSave = (goal, id) => {
	return dispatch => {
		return dispatch(sessionService.loadUser)
			.then(sess => {
				const options = {
					headers: {
						'Accept': 'application/json',
						'Content-Type': 'application/json',
						'Authorization': `Bearer ${sess.profile.access_token}`
					},
					method: 'post',
					body: JSON.stringify({activities:goal.activities})
				};

				return fetch(`${API2_URL}/proigualdad/goals/${id}/activities?include[0]=goal_activity${goal.id ? '&_method=PUT':''}`, options)
					.then(result => {
						if (result.status >= 200 && result.status < 300) {
							return result.json();
						} else {
							return result.json().then(Promise.reject.bind(Promise));
						}
					})
					.then(
						json => {
							if(_.isEmpty(goal.id)){
								history.push(`/proigualdad/metas/editar/${id}`);
							}
							return dispatch(activitiesGoalEditData(json));
						},
						error => {
							dispatch(newNotification({title: "¡Oh no!", content: error.message ? (error.errors ? `${error.message} - ${_.values(error.errors)}`:error.message):_.values(error), type: "danger"}));
							return dispatch(goalsFail(error.message ? (error.errors ? `${error.message} - ${_.values(error.errors)}`:error.message):_.values(error)));
						}
					);
			})
	}
};

export const goalDelete = (id) => {
	return dispatch => {
		return dispatch(sessionService.loadUser)
			.then(sess => {
				const options = {
					headers: {
						'Accept': 'application/json',
						'Content-Type': 'application/json',
						'Authorization': `Bearer ${sess.profile.access_token}`
					},
					method: 'delete',
				};

				dispatch(goalsRequest());
				return fetch(`${API2_URL}/proigualdad/goals/${id}`, options)
					.then(result => {
						if (result.status >= 200 && result.status < 300) {
							return result.json();
						} else {
							return result.json().then(Promise.reject.bind(Promise));
						}
					})
					.then(
						json => {
							dispatch(newNotification({title: "Éxito", content: json.message ? json.message:`Se eliminó la siguiente meta: <strong>${json.data.name}</strong>`, type: "success"}));
							dispatch(goalsShow());
							return dispatch(goalDeleted());
						},
						error => {
							dispatch(newNotification({title: "¡Oh no!", content: error.message ? (error.errors ? `${error.message} - ${_.values(error.errors)}`:error.message):_.values(error), type: "danger"}));
							return dispatch(goalsFail(error.message ? (error.errors ? `${error.message} - ${_.values(error.errors)}`:error.message):_.values(error)));
						}
					)
			})
	}
};

const goalsRequest = () => {
	return {
		type: GOALS_REQUEST,
		isFetching: true,
		timestamp: Date.now()
	}
};

const goalsListData = (json) => {
	return {
		type: GOALS_FETCH,
		isFetching: false,
		payload: json.data,
		timestamp: Date.now()
	}
};

const goalsData = (json) => {
	return {
		type: GOALS_SHOW,
		isFetching: false,
		payload: json.data,
		pages: {
			current: json.current_page,
			per_page: json.per_page,
			total: json.total
		},
		permissions: json.permissions,
		timestamp: Date.now()
	}
};

const goalEditData = (json) => {
	return {
		type: GOAL_EDIT,
		payload: json.data,
		permissions: json.permissions,
		timestamp: Date.now()
	}
};

const activitiesGoalEditData = (json) => {
	let activities = [];

	//_.mapKeys(json.data, (o) => activities[o.id] = {activity:true,mandatory:(o.goal_activity.mandatory ===1 ? true:false)});
	_.map(json.data, (o) => {
		return activities.push({...o, mandatory:(o.goal_activity.mandatory ===1 ? true:false)})
	});

	return {
		type: GOAL_ACTIVITIES,
		payload: activities,
		timestamp: Date.now()
	}
}

const goalsComplete = () => {
	return {
		type: GOAL_COMPLETE,
		isFetching: false,
		timestamp: Date.now()
	}
}

const goalDeleted = () => {
	return {
		type: GOAL_DELETE,
		isFetching: false,
		timestamp: Date.now()
	}
};

const goalsClear = () => {
	return {
		type: GOAL_CLEAR,
		payload: {
			activities:[]
		},
		timestamp: Date.now()
	}
};

const goalsFail = (error) => {
	return {
		type: GOAL_FAIL,
		isFetching: false,
		error: error,
		timestamp: Date.now()
	}
};


// WEBPACK FOOTER //
// ./src/actions/goals.js